export function registerDzsShowMore() {

//show more plugin
  (function ($) {
    $.fn.dzs_showmore = function (o) {

      var defaults = {};


      if (typeof o == 'undefined') {
        o = {};
      }
      if ($(this).attr('data-options')) {

        try {
          o = JSON.parse($(this).attr('data-options'));

        } catch (err) {

        }
      }

      o = $.extend(defaults, o);

      this.each(function () {

        var cthis = $(this);


        var count_needsLoading = 0
          , count_loaded = 0
        ;

        var $needsLoading = cthis.find('.needs-loading')
          , _lastVisible = null
          , _btnShowMore = null
          , _clipper = null
        ;

        let lastClipTopPosition = 0;


        init();

        function init() {

          count_needsLoading = $needsLoading.length;

          _clipper = cthis.find('.showmore-clipper').eq(0);
          _lastVisible = cthis.find('.showmore-last-visible').last();
          _btnShowMore = cthis.find('.btn-show-more').eq(0);

          cthis.find('.btn-show-more').bind('click', handle_mouse);

          let i3 = 0;

          if ($needsLoading.length === 0) {
            init_allloaded();
          } else {
            $needsLoading.each(function () {
              var $needsLoadingItem = $(this);


              var dataSrc = '';
              if ($needsLoadingItem.get(0).src) {
                dataSrc = $needsLoadingItem.get(0).src;
              }
              if ($needsLoadingItem.attr('data-src')) {
                dataSrc = $needsLoadingItem.attr('data-src');
              }
              if (dataSrc) {

                var img = new Image();

                img.onload = function () {


                  count_loaded++;

                  if (this._t) {
                    if (this._t.attr('data-src')) {
                      this._t.attr('src', this._t.attr('data-src'));
                    }
                  }

                  if (count_loaded >= count_needsLoading) {
                    init_allloaded();
                  }
                };

                img.src = dataSrc;
                img._t = $needsLoadingItem;


              }

              i3++;
            })
          }
        }

        function init_allloaded() {
          cthis.addClass('all-loaded');


          $(window).bind('resize', handle_resize);

          handle_resize();
        }

        function handle_resize(e) {

          if (_lastVisible && cthis && _lastVisible.offset()) {
            lastClipTopPosition = _lastVisible.offset().top - cthis.offset().top + _btnShowMore.outerHeight();
            if (cthis.hasClass('showing-more')) {

            } else {
              _clipper.outerHeight(lastClipTopPosition)
            }
          }


        }

        function handle_mouse(e) {
          const $t = $(this);

          if ($t.hasClass('btn-show-more')) {
            if (cthis.hasClass('showing-more')) {

              _clipper.css('height', _clipper.outerHeight());


              setTimeout(function () {
                _clipper.css({
                  'height': lastClipTopPosition
                }, {
                  queue: false
                  , duration: 300
                  , complete: function (arg) {
                  }
                })
              }, 10);


              cthis.removeClass('showing-more');
            } else {

              _clipper.css('height', 'auto');
              let clipOuterHeight = _clipper.outerHeight();


              _clipper.css('height', lastClipTopPosition);

              setTimeout(function () {
                _clipper.css({
                  'height': clipOuterHeight
                }, {
                  queue: false
                  , duration: 300
                  , complete: function (arg) {
                    $(this).css('height', 'auto');
                  }
                })
              }, 10);

              cthis.addClass('showing-more');
            }
          }
        }

      });
    }


    window.dzsshm_init = function (selector, settings) {

      $(selector).dzs_showmore(settings);


    };
  })(jQuery);
}